// Đơn vị thời gian của sim (ms). Thời gian luôn được truyền vào sim, không đọc giờ thật.
export const HOUR_MS = 3_600_000;
/** Một canh giờ = 2 giờ (đơn vị lịch cổ, GLOSSARY; WORLD ghi tốc độ hồi theo canh giờ). */
export const WATCH_HOURS = 2;
